





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    //
  }
})
export default class SkalaNyeri extends Vue {
  @Prop() skala!: number;

  warna = "";
  nyeriDescription = "";
  rangeSkala = ["0", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  nyeriLokasi = null;

  get showInputDetail(): boolean {
    return this.skala ? true : false;
  }

  @Watch("skala")
  changeNyeri(val) {
    if (this.skala == 0) {
      this.nyeriDescription = "Tidak Nyeri";
      this.warna = "green";
    } else if (this.skala < 4) {
      this.nyeriDescription = "Nyeri Ringan";
      this.warna = "#FBC02D";
    } else if (this.skala < 7) {
      this.nyeriDescription = "Nyeri Sedang";
      this.warna = "#F57C00";
    } else {
      this.nyeriDescription = "Nyeri Berat";
      this.warna = "#DD2C00";
    }

    this.$emit("skalaNyeri", val);
  }

  setJenis(val) {
    this.$emit("setNyeriJenis", val);
  }
}
